import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

import {
  LayoutTemplate,
  LogOut,
  Mailbox,
  MessageCircleQuestion,
  ScrollText,
  Users,
  Workflow,
} from "lucide-react";

import getLink, { LINK_TYPE } from "@/lib/links";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "@/context/AuthContext";
import { useEffect, useState } from "react";
import { Separator } from "../ui/separator";

export default function AdminSidebar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userEmail, logout } = useAuthContext();
  const [selectedPage, setSelectedPage] = useState("");

  useEffect(() => {
    const url = window.location.href.split("/");
    setSelectedPage(url[url.length - 1]);
  }, []);

  return (
    <Sidebar>
      <SidebarContent className="mt-16">
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenuItem
              id="users"
              onClick={() => {
                navigate(getLink(LINK_TYPE.USERS));
                setSelectedPage("users");
              }}
              className={`cursor-pointer flex gap-2 rounded-md outline-1 hover:bg-gray-100 hover:underline p-2 ${
                selectedPage == "users" ? "underline" : ""
              }`}
            >
              <Users size={16} />
              {t("admin.menu.users")}
            </SidebarMenuItem>
            <SidebarMenuItem
              id="emails"
              onClick={() => {
                navigate(getLink(LINK_TYPE.EMAILS));
                setSelectedPage("emails");
              }}
              className={`cursor-pointer flex gap-2 rounded-md outline-1 hover:bg-gray-100 hover:underline p-2 ${
                selectedPage == "emails" ? "underline" : ""
              }`}
            >
              <Mailbox size={16} />
              {t("admin.menu.email_templates")}
            </SidebarMenuItem>
            <SidebarMenuItem
              id="support"
              onClick={() => {
                navigate(getLink(LINK_TYPE.SUPPORT));
                setSelectedPage("support");
              }}
              className={`cursor-pointer flex gap-2 rounded-md outline-1 hover:bg-gray-100 hover:underline p-2 ${
                selectedPage == "support" ? "underline" : ""
              }`}
            >
              <MessageCircleQuestion size={16} />
              {t("admin.menu.support_faqs")}
            </SidebarMenuItem>
            <SidebarMenuItem
              id="documents"
              onClick={() => {
                navigate(getLink(LINK_TYPE.DOCUMENTS));
                setSelectedPage("documents");
              }}
              className={`cursor-pointer flex gap-2 rounded-md outline-1 hover:bg-gray-100 hover:underline p-2 ${
                selectedPage == "documents" ? "underline" : ""
              }`}
            >
              <ScrollText size={16} />
              {t("admin.menu.documents")}
            </SidebarMenuItem>
            <SidebarMenuItem
              id="hotel-integration"
              onClick={() => {
                navigate(getLink(LINK_TYPE.HOTEL_REGISTRATION_MANAGER));
                setSelectedPage("hotel-integration");
              }}
              className={`cursor-pointer flex gap-2 rounded-md outline-1 hover:bg-gray-100 hover:underline p-2 ${
                selectedPage == "hotel-integration" ? "underline" : ""
              }`}
            >
              <Workflow size={16} />
              {t("admin.menu.hotelIntegrations")}
            </SidebarMenuItem>
            <SidebarMenuItem
              id="ai"
              onClick={() => {
                navigate(getLink(LINK_TYPE.AI));
                setSelectedPage("ai");
              }}
              className={`cursor-pointer flex gap-2 rounded-md outline-1 hover:bg-gray-100 hover:underline p-2 ${
                selectedPage == "ai" ? "underline" : ""
              }`}
            >
              <LayoutTemplate size={16} />
              AI (Gennaro)
            </SidebarMenuItem>
            <SidebarMenuItem
              id="ari"
              onClick={() => {
                navigate(getLink(LINK_TYPE.ARI));
                setSelectedPage("ari");
              }}
              className={`cursor-pointer flex gap-2 rounded-md outline-1 hover:bg-gray-100 hover:underline p-2 ${
                selectedPage == "ari" ? "underline" : ""
              }`}
            >
              <LayoutTemplate size={16} />
              Prezzi e disponibilità
            </SidebarMenuItem>
            <SidebarMenuItem
              id="add_hotel"
              onClick={() => {
                navigate(getLink(LINK_TYPE.ADD_BOOKINGCOM_HOTEL));
                setSelectedPage("add-bookingcom-hotel");
              }}
              className="cursor-pointer flex gap-2 rounded-md outline-1 hover:bg-gray-100 hover:underline p-2"
            >
              Add Booking.com hotel
            </SidebarMenuItem>
            <SidebarMenuItem>
              <button
                className="hover:bg-gray-100 hover:underline ml-2 mt-2"
                onClick={() => {
                  throw new Error("Test Sentry!");
                }}
              >
                Sentry Test
              </button>
            </SidebarMenuItem>
            <Separator className="my-4" />
            <SidebarMenuItem
              className={`cursor-pointer flex gap-2 `}
              onClick={() => logout()}
            >
              <LogOut size={16} />
              {t("nav.logout")}
            </SidebarMenuItem>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>{userEmail}</SidebarFooter>
    </Sidebar>
  );
}
